<a href="{{logoutUrl}}" target="_self" class="link-logout"><i class="fa fa-sign-out" style="margin-right: 5px;"> </i>{{ 'menu.logout' | i18n }}</a>